import React, { useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Link, makeStyles, shorthands, tokens } from '@fluentui/react-components';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ReactTemplate } from '@bingads-webui-react/react-template';

const useTermsAndConditionsStyles = makeStyles({
  root: {
    ...shorthands.margin(tokens.spacingVerticalS, tokens.spacingHorizontalL, '-8px', tokens.spacingHorizontalL),
    alignItems: 'center',

    '& .fui-Checkbox__indicator': { marginLeft: 0 },
    '& .fui-Checkbox__label': { ...shorthands.padding(0) },
  },
});

export const TermsAndConditions = ({ checked, onChange }) => {
  const i18n = useContext(I18nContext);
  const classes = useTermsAndConditionsStyles();

  const label = useMemo(() => {
    const template = i18n.getString(_TL_('By selecting {{bold}}Go live{{/bold}}, you agree to the {{link}}LinkedIn Ads Agreement{{/link}}.'));

    return (
      <ReactTemplate
        template={template}
        model={{
          bold: text => <b>{text}</b>,
          link: text => (
            <Link
              aria-label={i18n.getString(_TL_('LinkedIn Ads Agreement'))}
              href="https://www.linkedin.com/legal/sas-terms"
              target="_blank"
              rel="noopener noreferrer"
              inline
            >
              {text}
            </Link>
          ),
        }}
      />
    );
  }, [i18n]);

  const handleChange = useCallback(() => onChange(!checked), [checked, onChange]);

  return (
    <Checkbox
      className={classes.root}
      label={label}
      checked={checked}
      onChange={handleChange}
    />
  );
};

TermsAndConditions.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};
